import { Network } from "lucide-react";
import { api } from "@/data/api";
import { useAsync } from "@/hooks/useAsync";
import { PageHeader, StatusBadge, DataTable, DemoBadge, AsyncBoundary, RowsSkeleton } from "@/components/common";

export default function Networks() {
  const { data, loading, error } = useAsync(() => api.getNetworks(), [], 20000);
  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader icon={Network} title="Redes" description="Redes Docker across os servidores da infraestrutura."
        breadcrumb={<><span>Infraestrutura</span><span>/</span><span className="text-foreground">Redes</span></>}
        actions={<DemoBadge className="hidden sm:inline-flex" />} />
      <AsyncBoundary loading={loading} error={error} skeleton={<RowsSkeleton />}>
        <DataTable
          columns={[
            { key: "name", header: "Rede", render: (r) => <span className="font-medium text-foreground">{r.name}</span> },
            { key: "server", header: "Servidor", render: (r) => <span className="font-mono text-xs">{r.server}</span> },
            { key: "driver", header: "Driver" },
            { key: "subnet", header: "Subnet", render: (r) => <span className="font-mono text-xs text-muted-foreground">{r.subnet}</span> },
            { key: "containers", header: "Containers", align: "right" },
            { key: "status", header: "Status", render: (r) => <StatusBadge status={r.status} size="sm" /> },
          ]}
          rows={data} keyField="name" testid="networks-table" />
      </AsyncBoundary>
    </div>
  );
}
